export const MuiTooltip = {
	styleOverrides: {
		tooltip: {
			backgroundColor: 'var(--default-white)',
			color: 'var(--neutral-900)',
			borderRadius: '4px',
			boxShadow: '0px 4px 12px 0px rgba(40, 103, 131, 0.16)',
			padding: '4px 8px',
			fontSize: '12px',
		},
	},
};
